import { render, staticRenderFns } from "./DepartamentosFormulario.vue?vue&type=template&id=d78dc5f6&"
import script from "./DepartamentosFormulario.vue?vue&type=script&lang=ts&"
export * from "./DepartamentosFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports